'use client';

import { useRouter } from 'next/navigation';
import { ROUTES } from '@/constants/application-urls';
import SearchField from '@/components/SearchField';
import { prependLocaleToPath } from '@/utils/helpers/url';
import useLocale from '@/hooks/useLocale';

interface HeaderSearchProps {
	placeholderLabel: string;
	onSearch?: () => void;
}

const HeaderSearch = ({ placeholderLabel, onSearch }: HeaderSearchProps) => {
	const { push } = useRouter();
	const locale = useLocale();

	const handleSearch = (searchValue: string) => {
		if (!searchValue.trim()) return;

		const searchUrl = prependLocaleToPath(ROUTES.PRODUCT_SEARCH + encodeURIComponent(searchValue), locale);
		push(searchUrl);

		if (onSearch) {
			onSearch();
		}
	};

	return (
		<SearchField
			placeholderLabel={placeholderLabel}
			onSearch={handleSearch}
			sx={{
				p: {
					xs: '0 16px',
					md: '0 30px',
				},
			}}
		/>
	);
};

export default HeaderSearch;
